import React from 'react';
import { type DisplayProps } from 'styled-system';

import VisuallyHidden from 'common/components/VisuallyHidden';
import { useLocalization } from 'common/providers/LocaleProvider';
import FooterLinkSectionContents from './FooterLinkSectionContents';
import GeneralOnlyFooterLinkSection from './GeneralOnlyFooterLinkSection';
import Separator from './Separator';
import type { GetSectionParams } from './utils';
import { getSections, isGeneralOnly } from './utils';

interface FooterLinkSectionProps extends GetSectionParams {
  separatorStyles?: DisplayProps;
}

const FooterLinkSection = ({
  general,
  help,
  payment,
  international,
  shipping,
  social,
  separatorStyles,
}: FooterLinkSectionProps) => {
  const { t } = useLocalization();
  const sections = getSections({
    general,
    help,
    payment,
    international,
    shipping,
    social,
  });

  return (
    <section data-corgi-id="footer-link-section">
      <Separator display="none" {...separatorStyles} />
      {isGeneralOnly(sections) ? (
        <GeneralOnlyFooterLinkSection section={sections[0].data} />
      ) : (
        <>
          <VisuallyHidden as="h2">{t('footer_link_section_header')}</VisuallyHidden>
          <FooterLinkSectionContents sections={sections} />
        </>
      )}
    </section>
  );
};

export default FooterLinkSection;
